import $ from 'jquery';

class MessageHandler {
    constructor() {
        this.player = window.player;
        this.been_paused = false;
        this.pause_button = '';
    }

    // Handle events from embed's parent page
    messageHandler(event) {
        var command;

        // Ignore ad messages
        if (!event.data.command) {
            return;
        }

        command = event.data.command;

        if (this.been_paused && command === 'play') {
            return;
        }
        switch (command) {
        case 'play':
            // Only set to play video when we're not in ad playback state, otherwise the video will start in middle of ad
            if (this.player.ads.state !== 'ad-playback') {
                this.pauseListener();
                return this.player.play();
            }
            this.player.ima.resumeAd();
            break;
        case 'pause':
            this.player.ima.pauseAd();
            return this.player.pause();
        case 'mute':
            return this.player.muted(true);
        case 'unmute':
            return this.player.muted(false);
        default:
            return this.player;
        }
    }

    pauseListener() {
        this.pause_button = $('.vjs-play-control');
        this.pause_button.one('click', function () {
            this.been_paused = true;
        }.bind(this));
    }

    // Set Listeners
    on() {
        window.addEventListener('message', this.messageHandler.bind(this));
    }
}

export default new MessageHandler();
